// extracted by mini-css-extract-plugin
export default {"verticalContainer":"VerticalContainer_verticalContainer__yedEi"};